import React from "react";
import "./css/Loader.css"; 

const Loader = () => {
  return (
    <div className="loader">
      {Array.from({ length: 12 }).map((_, i) => (
        <div key={i} className={`bar${i + 1}`}></div>
      ))}
    </div>
  );
};

export default Loader;
